const advertise = {
    dfdh: 'Số điện thoại của đối tác:',
    sjmc: 'Tên doanh nghiệp',
    qsrsj: 'Nhập tên doanh nghiệp',
    sjbzj: 'Tiền đặt cọc của doanh nghiệp',
    wcl: 'Tỷ lệ hoàn thành trong 30 ngày',
    zcd: 'Tổng đơn hàng (Mua/Bán)',
    cd: 'Đơn hàng trong 30 ngày',
    c: 'Lần',
    fz: 'Phút',
    pjfx: 'Thời gian xử lý trung bình',
    zcsj: 'Thời gian đăng ký:',
    fbjy: 'Giao dịch Fiat lần đầu:',
    yxbd: 'Liên kết Email',
    sjbd: 'Liên kết Số điện thoại',
    cjsm: 'Xác minh danh tính cấp cơ bản',
    gjsm: 'Xác minh danh tính cấp cao',
    buy: 'Mua',
    sell: 'Bán',
    market: 'Thị trường',
    djfs: 'Phương thức định giá',
    ggid: 'ID Quảng cáo',
    time: 'Thời gian',
    type: 'Loại',
    ptgg: 'Quảng cáo thông thường',
    gdjg: 'Giá cố định',
    fdjg: 'Giá động',
    yjfw: 'Khoảng giá chênh lệch',
    unitPrice: 'Giá mỗi đơn vị',
    totalPrice: 'Tổng giá trị',
    sysl: 'Số lượng còn lại',
    ywcsl: 'Số lượng đã hoàn thành',
    cz: 'Hành động',
    xj: 'Ngừng quảng cáo',
    sj: 'Đăng quảng cáo',
    edit: 'Chỉnh sửa',
    delete: 'Xóa',
    all: 'Tất cả',
    qdxjm: 'Bạn có chắc chắn muốn ngừng quảng cáo này không?',
    qdxj: 'Xác nhận ngừng quảng cáo',
    qdsjm: 'Bạn có chắc chắn muốn đăng quảng cáo này không?',
    qdsj: 'Xác nhận đăng quảng cáo',
    confirm: 'Xác nhận',
    cancel: 'Hủy',
    qdscm: 'Bạn có chắc chắn muốn xóa quảng cáo này không?',
    deleteAdvertise: 'Xóa Quảng cáo',
  
    tjgm: 'Thống kê Mua',
    tjcs: 'Thống kê Bán',
    coins: 'Loại tiền',
    day7: '7 ngày',
    day15: '15 ngày',
    day30: '30 ngày',
    tj: 'Thống kê',
    mrsl: 'Số lượng Mua',
    mcsl: 'Số lượng Bán',
    mrjj: 'Giá trung bình Mua',
    mcjj: 'Giá trung bình Bán',
    zcje: 'Tổng chi tiêu',
    srje: 'Tổng thu nhập',
    zsxf: 'Tổng phí giao dịch',
    cjdd: 'Đơn đặt hàng đã thực hiện',
    zdxx: 'Thông tin đơn đặt hàng',
    tips: 'Lưu ý: Đối với mỗi cặp giao dịch, thống kê Mua và Bán chỉ có thể xuất 100 lần mỗi ngày',
    dcdd: 'Xuất đơn đặt hàng',
    orderNo: 'Mã đơn hàng',
    jybz: 'Tiền giao dịch',
    number: 'Số lượng',
    total: 'Tổng cộng',
    fee: 'Phí',
    zd: 'Đơn đặt hàng',

    tjskfs: 'Thêm phương thức nhận thanh toán',
    skfs: 'Phương thức nhận thanh toán',
    name: 'Tên',
    payAccount: 'Tài khoản',
    sk: 'Nhận thanh toán',
    cz: 'Hành động',
    delete: 'Xóa',
    edit: 'Chỉnh sửa',
    qdsc: 'Xác nhận xóa?',
    tip: 'Gợi ý',
    deleted: 'Đã hủy xóa',
    xzskfstt: 'Thêm phương thức nhận thanh toán',
    xgskfstt: 'Chỉnh sửa phương thức nhận thanh toán',
    khmc: 'Tên người thụ hưởng',
    yhkh: 'Số tài khoản ngân hàng',
    khh: 'Ngân hàng phát hành',
    khhszd: 'Địa điểm ngân hàng',
    khhmc: 'Tên chi nhánh ngân hàng',
    wxzh: 'Tài khoản WeChat',
    zfbzf: 'Thanh toán Alipay',
    ewmsc: 'Tải lên mã QR',
    jymm: 'Mật khẩu giao dịch',
    srkhh: 'Nhập ngân hàng phát hành',
    xzszd: 'Chọn địa điểm ngân hàng phát hành',
    srkhmc: 'Nhập tên chi nhánh ngân hàng',
    srzh: 'Nhập số tài khoản',
    scskm: 'Vui lòng tải lên mã nhận thanh toán',
    srjymm: 'Nhập mật khẩu giao dịch',
    scwjgd: 'Dung lượng tệp ảnh đại diện không được vượt quá 2MB!',
  
    jnbzj1: 'Dưới tư cách là {gradeName}, bạn đã đặt cọc {margin} USDT. Số dư quảng cáo còn lại hiện tại là {amount} USDT',
    k: 'Có thể',
    add: 'Thêm',
    or: 'hoặc',
    reduce: 'Giảm',
    margin: 'Đặt cọc',
    sqsxf: '*Sàn sẽ thu phí {fee}% từ số giao dịch quảng cáo như là phí giao dịch',
    hqed: 'Ngay lập tức trở thành một nhà kinh doanh được chứng nhận để nhận giới hạn cao hơn',
    want: 'Tôi muốn',
    bb: 'Mua bán',
    price: 'Giá',
    ckj: '*Giá tham khảo trên thị trường {price} {fiatCurrency}/USDT. Giá cố định không thay đổi theo biến động của thị trường',
    jyjg: 'Giá giao dịch',
    mdjg: 'Giá gắn kết',
    gxhl: '*Tỉ giá thời gian thực của ngân hàng và nhiều sàn giao dịch, cập nhật mỗi 5 phút',
    szyj: 'Thiết lập Phí chênh lệch',
    zjjy: '*Có thể nhập số âm, tức là giao dịch giảm giá trên giá cố định',
    yjsz: '*Giá giao dịch = Giá cố định * (1 + Phí chênh lệch)',
    jyxz: 'Hạn chế giao dịch',
    jysl: 'Số lượng giao dịch',
    sygged: '*Số lượng giao dịch không thể vượt quá số dư quảng cáo còn lại hiện tại',
    zxxe: 'Giới hạn mỗi lần giao dịch nhỏ nhất',
    zdxe: 'Giới hạn mỗi lần giao dịch lớn nhất',
    fkqx: 'Thời hạn thanh toán',
    xnfk: '*Thanh toán cần được thực hiện trong khoảng thời gian này',
    fkfs: 'Phương thức thanh toán',
    xzskfs: '*Tối đa 5 phương thức thanh toán có thể được thêm cho mọi loại tiền',
    yhjy: 'Không giao dịch với người dùng chưa hoàn thành xác minh danh tính cao cấp',
    jygg: '*Chỉ người dùng đã hoàn thành xác minh danh tính cơ bản không thể tham gia quảng cáo',
    cyjy: 'Hãy chọn người dùng chưa hoàn thành số lượng mua được chỉ định, không thể tham gia giao dịch',
    bmfx: '*Người dùng đã hoàn thành mua sẽ giảm nguy cơ xuất phát từ nguồn tiền không rõ',
    qxz: 'Chọn',
    jybz: 'Ghi chú giao dịch',
    tyzs: 'Tôi đã biết và đồng ý tuân thủ',
    jygz: '《Quy tắc giao dịch》',
    yzm: 'Mã xác nhận',
    save: 'Lưu lại',
    fbgg: 'Đăng quảng cáo',
    jsbzjcg: 'Giảm đặt cọc thành công',
    zjbzjcg: 'Thêm đặt cọc thành công',
    xzfs: 'Vui lòng chọn phương thức thanh toán hoặc thanh toán',
    bankTip1: 'Không thể thêm hơn ba phương thức thanh toán bằng thẻ ngân hàng',
    wxTip2: 'Không thể thêm hơn ba phương thức thanh toán WeChat',
    zfbTip3: 'Không thể thêm hơn ba phương thức thanh toán Alipay',
    syjg: 'Vui lòng nhập giá',
    syjysl: 'Vui lòng nhập số lượng giao dịch',
    zxxe: 'Vui lòng nhập giới hạn mỗi lần giao dịch nhỏ nhất',
    zdxe: 'Vui lòng nhập giới hạn mỗi lần giao dịch lớn nhất',
    fkqx: 'Vui lòng nhập thời hạn thanh toán',
    tyjygz: 'Vui lòng đồng ý với quy tắc giao dịch',
    tpyzm: 'Vui lòng nhập mã xác nhận hình ảnh',
    jydx: 'Đối tác giao dịch',

    zjbzj: 'Thêm đặt cọc',
    jsbzj: 'Giảm đặt cọc',
    xzdgged: 'Số dư quảng cáo tối đa hiện tại',
    zjbzjse: 'Số tiền thêm vào đặt cọc',
    jsbzjse: 'Số tiền giảm đặt cọc',
    zjhbzjed: 'Tổng số tiền cọc sau khi thêm',
    jshbzjed: 'Tổng số tiền cọc sau khi giảm',
    balance: 'Số dư',
    sy: 'Còn lại',
    kzj: 'Có thể thêm vào',
    kjs: 'Có thể giảm',
    otcsjxy: 'Quy tắc dịch vụ nhà kinh doanh OTC',
    xsgz: 'Hướng dẫn cho người mới',
    jygz: 'Quy tắc giao dịch',
    jnbzj: 'Để đảm bảo OTC hợp pháp và tuân thủ các quy tắc, chúng tôi yêu cầu người kinh doanh đặt cọc một số tiền nhất định;',
    zjjnbzj: 'Cọc bảo đảm chia thành hai phần: số tiền cơ bản và số tiền thêm vào, số tiền cơ bản là bắt buộc và số tiền thêm vào có thể chọn có hoặc không;',
    kxs: 'Đặt cọc số tiền cơ bản sẽ nhận được',
    fbgged: 'quảng cáo với giới hạn cao hơn (tính bằng USDT, nếu bạn đăng quảng cáo CNYT sẽ được tính dựa trên tỉ giá hối đoái);',
    ggedbl: 'Tỉ lệ giữa số tiền thêm vào và giới hạn quảng cáo là',
    eg: 'Nếu thêm vào 100 USDT, giới hạn quảng cáo sẽ tăng thêm 100 x',
    ggzedjs: 'Công thức tính giới hạn quảng cáo là: Giới hạn quảng cáo cơ bản + Giới hạn quảng cáo thêm vào x',
    ttsjzxed: 'Số tiền thêm vào tối thiểu cho nhà kinh doanh thông thường là',
    zdedw: 'Số tiền tối đa là',
    mgsjzd: 'Mỗi nhà kinh doanh tối đa có thể đăng ba quảng cáo mua và ba quảng cáo bán.',
    hljj: 'Tỉ giá đổi USDT thành CNYT được lấy từ giá trung bình của cặp giao dịch tương ứng trên sàn BiKing trong 24 giờ qua (ghi lại mỗi giờ, loại bỏ giá cao nhất và giá thấp nhất), làm giá trung bình. Đồng thời, khi tỉ giá thay đổi, số tiền quảng cáo đã đăng sẽ không thay đổi.',
    jcbzj: 'Số tiền cọc cơ bản',
    xt: 'Tùy chọn',
    njhded: 'Số tiền quảng cáo bạn sẽ nhận được là:',
    mbye: 'Số dư mua tiền:',
    zhzcbz: 'Số dư tài khoản không đủ, bạn có thể chuyển từ tài khoản tài sản',
    qhz: 'Chuyển đến',
    qdjnbzj: 'Xác nhận đặt cọc cơ bản',
    tjbzj: 'Thêm cọc bảo đảm',
    sqsjcg: 'Đăng ký nhà kinh doanh thành công',
    exchange:'Chuyển đổi tỷ giá'
  }
  export {
      advertise
  }


// WEBPACK FOOTER //
// ./src/i18n/lang/advertise/vi.js